import request from "@/request";
/* ------------------------------------角色管理------------------------------------ */
//角色列表
export function role_list(data) {
  return request({
    url: "auth/role_list",
    method: "post",
    data,
  });
}
export function role_all_list(data) {
  return request({
    url: "auth/role_all_list",
    method: "post",
    data,
  });
}

//菜单列表
export function menu_list(data) {
  return request({
    url: "auth/menu_list",
    method: "post",
    data,
  });
}

//添加角色
export function role_add(data) {
  return request({
    url: "auth/role_add",
    method: "post",
    data,
  });
}

//角色菜单详情
export function role_detail(data) {
  return request({
    url: "auth/role_detail",
    method: "post",
    data,
  });
}

//删除角色
export function role_delete(data) {
  return request({
    url: "/auth/role_delete",
    method: "post",
    data,
  });
}

//编辑角色
export function role_edit(data) {
  return request({
    url: "/auth/role_edit",
    method: "post",
    data,
  });
}

/* ------------------------------------用户列表------------------------------------ */
//用户列表
export function user_list(data) {
  return request({
    url: "user/list",
    method: "post",
    data,
  });
}
//获取户详情
export function user_details(id) {
  return request({
    url: "user/details/" + id,
    method: "get",
  });
}

//新增用户
export function user_add(data) {
  return request({
    url: "user/add",
    method: "post",
    data,
  });
}

//删除用户
export function user_del(id) {
  return request({
    url: "user/del/" + id,
    method: "delete",
  });
}

//编辑用户
export function user_edit(id, data) {
  return request({
    url: "user/edit/" + id,
    method: "post",
    data,
  });
}

//用户启用/禁用
export function on_off(id, data) {
  return request({
    url: "user/on_off/" + id,
    method: "post",
    data,
  });
}

//获取所有报审机构
export function getAll_list() {
  return request({
    url: "organizations/all_list",
    method: "post",
  });
}

//获取所有审核机构
export function publish_list() {
  return request({
    url: "publish/all_list",
    method: "get",
  });
}

//获取角色权限(绑定角色)
export function role_list_with_auth() {
  return request({
    url: "auth/role_list_with_auth",
    method: "get",
  });
}

//拉取所有专家的权限
export function specialist_premission_list(data) {
  return request({
    url: "user/specialist_premission_list",
    method: "get",
    data,
  });
}

/* ------------------------------------审核人员任务分配------------------------------------ */
//获取列表
export function auditor_user_set_list(data) {
  return request({
    url: "auditor_task/auditor_user_set_list/?" + data,
    method: "get",
  });
}

//获取人员列表
export function auditor_user_list(data) {
  return request({
    url: "auditor_task/auditor_user_list/?" + data,
    method: "get",
  });
}

//创建任务
export function auditor_user_set_add(data) {
  return request({
    url: "auditor_task/auditor_user_set_add",
    method: "post",
    data,
  });
}

//修改任务
export function auditor_user_set_edit(data) {
  return request({
    url: "auditor_task/auditor_user_set_edit",
    method: "post",
    data,
  });
}

//启用禁用人员分配
export function auditor_user_set_status(data) {
  return request({
    url: "auditor_task/auditor_user_set_status",
    method: "post",
    data,
  });
}
